import React, { useRef } from "react";
import { Tooltip } from "@mui/material";
import Image from "src/shared/Image";

interface ProfileAvatarProps {
  image: string;
  onImageChange: (file: File) => void;
  tooltipText?: string;
  size?: string;
  className?: string;
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({ image, onImageChange, tooltipText = "Change Image", size = "w-36 h-36", className = "" }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) onImageChange(file);
  };

  return (
    <div className={`flex-shrink-0 ${className}`}>
      <input ref={fileInputRef} type="file" accept="image/*" onChange={handleFileChange} className="hidden" />
      <Tooltip title={tooltipText} placement="bottom" arrow>
        <div onClick={() => fileInputRef.current?.click()} className="cursor-pointer relative group">
          <Image imagePath={image} className={`${size} border border-gray-300 rounded-full object-cover transition-opacity duration-200 group-hover:opacity-75`} company={true} />
          {/* Overlay hint on hover */}
          <div className="absolute inset-0 flex items-center justify-center rounded-full bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-200">
            <span className="text-white text-[10px] font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-center px-1">Change</span>
          </div>
        </div>
      </Tooltip>
    </div>
  );
};

export default ProfileAvatar;
